module.exports = __webpack_public_path__ + "img/success.637b65ac.png";